import(/* webpackMode: "eager" */ "/workspace/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/workspace/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["MagicLinkHandler"] */ "/workspace/web/src/app/(web)/login/MagicLinkHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginButtonsContainer"] */ "/workspace/web/src/features/auth/login/components/LoginButtonsContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginErrorMessageHandler"] */ "/workspace/web/src/features/auth/login/components/LoginErrorMessageHandler.tsx");
